import request from "@/config/utils/request";
import { addUrlPerFix } from "@/basa/utils";

export function getAuthMenu(data) {
  return request({
    url: "apis/ebs/app/getAuthMenu",
    method: "post",
    data
  });
}

export function getDetail(data) {
  return request({
    url: addUrlPerFix(process.env.VUE_APP_BASEP_URL) + "/apis/basap/getDetail",
    method: "post",
    data
  });
}

export function getLogin(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) +
      "/apis/basap/users/signup/getLogin",
    method: "post",
    data
  });
}

export function getAppToken(data) {
  return request({
    url: "/apis/ebs/oauth2/codeRedirect",
    method: "post",
    data
  });
}
export function goIccec(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) +
      "/apis/basap/esi/login/iccec",
    method: "post",
    data
  });
}
//通过menuId调取接口
export function getMenuBymenuId(data) {
  return request({
    url: "/apis/ebs/jurisdiction/qryOperationJurisdction",
    method: "post",
    data
  });
}

//校验是否弹窗是否有权限
export function openDiagoByrole(data) {
  return request({
    url: "/apis/ebs/user/checkAppUser",
    method: "post",
    data
  });
}
//校验是否弹窗是否有权限并允许绑定
export function agreeDiagoByrole(data) {
  return request({
    url: "/apis/ebs/user/addAppUser",
    method: "post",
    data
  });
}
export function getUserInfo(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) + "/apis/basap/getUserInfo",
    method: "post",
    data
  });
}

// 帮助中心意见反馈
export function insertAppAdvice(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) +
      "/apis/basap/insertAppAdvice",
    method: "POST",
    data
  });
}
